import { render, staticRenderFns } from "./mallInfo.vue?vue&type=template&id=fdba4cd6&scoped=true"
import script from "./mallInfo.vue?vue&type=script&lang=ts"
export * from "./mallInfo.vue?vue&type=script&lang=ts"
import style0 from "./mallInfo.vue?vue&type=style&index=0&id=fdba4cd6&prod&lang=less&scoped=true"
import style1 from "./mallInfo.vue?vue&type=style&index=1&id=fdba4cd6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdba4cd6",
  null
  
)

export default component.exports